import { resolveIdentifier } from "mobx-state-tree"
import { Product } from "store/model/traxis/Product"
import { lazyCallback } from "store/ModelTools"
import { rootStore } from "store/RootStore"
import { ClassAbstract } from "store/ClassTools"

export class SingletonStore extends ClassAbstract {
	/**
	 * @returns {import("store/api/GetProducts").GetProducts}
	 */
	get products() {
		return lazyCallback(this, "products", () => rootStore.api.GetProducts()?.fetchData())
	}

	productsResolveIdentifier(id) {
		return resolveIdentifier(Product, this.products?.Data, id)
	}

	/**
	 * @returns {import("store/api/GetCustomer").GetCustomer}
	 */
	get customer() {
		return lazyCallback(this, "customer", () => rootStore.api.GetCustomer()?.fetchData())
	}

	/**
	 * @returns {import("store/api/GetProfile").GetProfile}
	 */
	get profile() {
		return lazyCallback(this, "profile", () => rootStore.api.GetProfile()?.fetchData())
	}
}
